/*
 * @Descripttion:
 * @Author: baiyang
 * @Date: 2022-03-01 14:57:51
 * @LastEditors: baiyang
 * @LastEditTime: 2022-03-08 16:43:34
 */
/**
 * @constant 广告类型
 */
export const AD_TYPE = {
  WEBAD: 2, // web广告
  CHANGYI: 10, // 畅移卡劵
  wxHalfAd: 12, // 微信半屏广告
  WX_SYNTHESIZE_POP: 13, // 微信三联弹窗
  WX_SYNTHESIZE_BANNER: 14, // 微信三联banner广告
  WX_SYNTHESIZE_LIST: 15, // 微信三联列表广告
}
/**
 * @constant 广告统计类型
 */
export const AD_ACTINO_TYPE = {
  exposure: 1, // 广告曝光
  click: 2 // 点击
}
/**
 * @constant 广告统计类型
 */
export const REPORT_TYPE = {
  CLICK: 1, // 接口曝光
  COMPLETE: 2 // 获取到就曝光
}
/**
 * @constant 展示web广告
 */
export const WEB_AD = {
  SHOW: true,
  NOT_SHOW: false
}
